import { render, staticRenderFns } from "./deviceManagement.vue?vue&type=template&id=52cf61a7&scoped=true"
import script from "./deviceManagement.vue?vue&type=script&lang=js"
export * from "./deviceManagement.vue?vue&type=script&lang=js"
import style0 from "./deviceManagement.vue?vue&type=style&index=0&id=52cf61a7&prod&scoped=true&lang=scss"
import style1 from "./deviceManagement.vue?vue&type=style&index=1&id=52cf61a7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cf61a7",
  null
  
)

export default component.exports